//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, { useState, useCallback, useEffect, useContext } from "react";
import { CSVLink } from "react-csv";
import * as moment from "moment";
import { toast } from "react-toastify";

// custom pages
import { styles } from "./styles";
import KpiReport from "apis/kpiReport/KpiReport";
import { pointexpirationmonthly } from "./config/config";
import { toastCss, successCss } from "assets/styleJS/global";
import NoData from "components/Table/NoData";
import Loader from "components/Loader/Loader";
import Context from "context/context";

// material-ui
import { withStyles } from "@material-ui/core/styles";
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TextField from "@material-ui/core/TextField";
import CircularProgress from "@material-ui/core/CircularProgress";
import MenuItem from "@material-ui/core/MenuItem";
import { useTranslation } from 'react-i18next';


// material-ui icons
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";


const GlobalCss = withStyles({
    "@global": {
        ".MuiDialog-scrollPaper": {},
        ".MuiDialog-paperWidthSm": {
            overflow: "hidden",
            maxWidth: "none",
        },
        ".MuiDialog-paper ": {},
    },
})(() => null);

export default function PointExpirationMonthly(props) {
    const { state, dispatch } = useContext(Context);

    const { page, setDisableDropdown } = props;
    const { getyearmonthAPI,benefitCodeWeeklyReportAPI ,monthlypointsexpiration} = KpiReport();
   
    const classes = styles();
  const { t, i18n } = useTranslation();
  const [year, setyear] = useState([]);
  const [month, setmonth] = useState([]);



    
    const [states, setstates] = useState({
        columns: [],
        selectedColumns: [],
        selectedFields: [],
        selectedHeaders: [],
        dialog: false,
        data: [],
        response: false,
        startDate: null,
        endDate: null,
        dateApplied: false,
        filterColumn: "",
        filterValue: "",
        filterApplied: false,
        groupBy: "",
        groupByApplied: false,
        pLoading: false,
        eLoading: false,
        errorDialog: false,
        errorCount: "",
        month:"",
        year:""

        
    });

    const setStates = useCallback((newState) => {
        setstates((states) => ({ ...states, ...newState }));
    }, []);

    // setting checkboxes
    useEffect(() => {
        let label = pointexpirationmonthly?.columns?.map((c) => c.label);
        setStates({ columns: label, selectedColumns: label });
    }, []);

    useEffect(() => {
        getyearmonth()
      }, [])

    async function getyearmonth() {
        try {
          const monthyear = await getyearmonthAPI();
          setyear(monthyear.year);
          setmonth(monthyear.month)
        } catch (e) {
          console.log({ e });
        }
      }

   

    const handleGetBurn = async () => {
        
        //     setDisableDropdown(true);
        
        let selectedColumnKeys = [];

        let selectedObj = [];
        let selectedHeaders = [];

        states.selectedColumns.map(
            (s) => (selectedObj = [...selectedObj, { label: s }])
        );

        pointexpirationmonthly.columns.map((c) => {
            selectedObj.map((s) => {
                if (c.label === s.label) {
                    selectedHeaders = [...selectedHeaders, c];
                }
            });
        });

        pointexpirationmonthly.columns.map((c, i) => {
            if (states.selectedColumns?.includes(c.label)) {
                selectedColumnKeys = [...selectedColumnKeys, c.key];
                return;
            }
        });

        setStates({
            selectedFields: selectedColumnKeys,
            selectedHeaders: selectedHeaders,
        });
       
        let values;
        values = {
                           ...values,
                            year: states.year,
                            month: states.month,
                        };
        dispatch({ type: "SET_LOADING", payload: true });
        let res = await monthlypointsexpiration(values);
        if (res && res?.type === "ERROR") {
            dispatch({ type: "SET_REPORT_RES_COUNT", payload: 0 });
            setStates({
                pLoading: false,
                eLoading: false,
                errorDialog: true,
                errorCount: res?.count,
            });
            setDisableDropdown(false);
        }
        if (res && res?.data) {
            dispatch({ type: "SET_REPORT_RES_COUNT", payload: 0 });
            setStates({
                data: res.data,
                response: true,
                pLoading: false,
                eLoading: false,
            });
            setDisableDropdown(false);
        }
        if (res && res.data) {
            // setIsLoading(false);
            setStates({data:res.data});

            dispatch({ type: "SET_LOADING", payload: false });
           
            if (res.data.length === 0) {
              toast.success(t("No Data Found"), { toastId: "no-report-date" });
              return false;
            }
           
            return true;
          }
        }

        console.log(states?.data,"data")

        
        
    
      


   
    const pointsFormat = (value) => {
        if (value) {
            var nfObject = new Intl.NumberFormat("en-US");
            var points = nfObject.format(value);
            return points;
        }
        return "";
    };

    const pointsDecimalFormat = (value) => {
        if (value) {
            var points = value.toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
            return points;
        }
        return "";
    };

    const monthOrder = ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"];

    return (
        <div>
             <GlobalCss />
            <div className={classes.headText}>
                 {/* {'Select date range'}{" "}  */}
                {states.dateApplied && (
                    <React.Fragment>
                        <span className={classes.appliedSpan}>
                            <CheckCircleIcon />
                        </span>
                        <span
                            className={classes.removeSpan}
                            onClick={() => {
                                setStates({
                                    dateApplied: false,
                                    year: "",
                                    month: "",
                                });
                            }}
                        >
                            {'Remove'}
                        </span>
                    </React.Fragment>
                )} 
            </div>
            <div className={classes.inputsDiv}>
                <Grid container spacing={0}>
                    <Grid item xs={12} md={3}>
                    <TextField
                    style={{width:"150px"}}
              id={"report"}
              label={"Select Year"}
              select
              required
              type={"text"}
            //   className={classes.input}
              value={states.year}
              onChange={(e) => {
                setStates({
                  year: e.target.value,
                });
              }}
            //   disabled={disableDropdown}
            >
              {year.map((r, i) => (
                <MenuItem value={r.year} key={i}>
                  {r.year}
                </MenuItem>
              ))}
            </TextField>
                    </Grid>
                    <Grid item xs={12} md={3}>
                    <TextField
                    style={{width:"150px"}}
              id={"report"}
              label={"Select Month"}
              select
              required
              type={"text"}
            //   className={classes.input}
              value={states.month}
              onChange={(e) => {
                setStates({
                  month: e.target.value,
                });
              }}
            //   disabled={disableDropdown}
            >
              {month
            .sort((a, b) => monthOrder.indexOf(a.month.toLowerCase()) - monthOrder.indexOf(b.month.toLowerCase()))
              .map((r, i) => (
                <MenuItem value={r.month} key={i}>
                  {r.month}
                </MenuItem>
              ))}
            </TextField>
                    </Grid>
                </Grid>
            </div>
            <div style={{ color: "gray", padding: 10 }}>
                {`*Max  file count can be exported ${pointsFormat(800000)}`}
            </div>
            <CSVLink
                id="csv"
                data={states.data}
                headers={states.selectedHeaders}
                skipEmptyLines={true}
                filename={
                    `Pointexpirationmonthly` + " " + moment(new Date()).format("MM-DD-YYYY,h:mm A") + ".csv"
                }
                className={classes.CSVlink}
            />
            <div className={classes.exportAndPreview}>
                <Button
                    className={classes.previewBtn}
                    onClick={async () => {
                        if ((states.year && !states.month) || (!states.year && states.month)) {
                            toast.error("Please select the both year and month values",{
                                toastId: "empty-fields"
                            });
                            return;
                        }
                        if (!states.year && !states.month) {
                            toast.error("Please select  year and month values",{
                                toastId: "empty-fields-both"
                            });
                            return;
                        }
                       
                        setStates({ response: false, data: [], pLoading: true });
                        let res = await handleGetBurn();
                        if (res) {
                            setStates({ dialog: true });
                        }
                    }}
                    disabled={states.pLoading || states.eLoading}
                >
                    {states.pLoading ? (
                        <React.Fragment>
                            <CircularProgress
                                style={{ height: 25, width: 25 }}
                                variant="determinate"
                                value={state.reportResCount}
                            />
                            &nbsp;
                            <span style={{ color: "#305698", fontWeight: "bold" }}>
                                {state.reportResCount == 0 ?
                                <div class="snippet">
                                    <div class="stage">
                                        <div class="dot-typing-p"></div>
                                    </div>
                                </div> 
                                : `${state.reportResCount}%`}
                            </span>
                        </React.Fragment>
                    ) : (
                        "Preview"
                    )}
                </Button>
                <Button
                    className={classes.exportBtn}
                    onClick={async () => {
                        if ((states.year && !states.month) || (!states.year && states.month)) {
                            toast.error("Please select the both year and month values",{
                                toastId: "empty-fields"
                            });
                            return;
                        }
                        if (!states.year && !states.month) {
                            toast.error("Please select  year and month values",{
                                toastId: "empty-fields-both"
                            });
                            return;
                        }
                       
                       
                        setStates({ response: false, data: [], eLoading: true });
                        let res = await handleGetBurn();
                        if (res) {
                            let data = [];
                            document.getElementById("csv").click();
                        }
                    }}
                    disabled={states.eLoading || states.pLoading}
                >
                    {states.eLoading ? (
                        <React.Fragment>
                            <CircularProgress
                                style={{ height: 25, width: 25, color: "#fff" }}
                                variant="determinate"
                                value={state.reportResCount}
                            />
                            &nbsp;
                            <span style={{ color: "#fff", fontWeight: "bold" }}>
                                {state.reportResCount == 0 ?
                                <div class="snippet">
                                    <div class="stage">
                                        <div class="dot-typing-e"></div>
                                    </div>
                                </div> 
                                : `${state.reportResCount}%`}
                            </span>
                        </React.Fragment>
                    ) : (
                        "Export CSV"
                    )}
                </Button>
                {(states.eLoading || states.pLoading) && <div style={{ color: 'red', marginLeft: 10 }}>*Please wait don't reload the page, system is processing</div>}
            </div>
            <Dialog
                onClose={() => {
                    setStates({ dialog: false });
                }}
                aria-labelledby="simple-dialog-title"
                open={states.dialog}
            >
                <div className={classes.mainDiv}>
                    <Grid container spacing={0}>
                        <Grid item xs={12} className={classes.gridOne}>
                            {page + " " + "Report"}
                            <HighlightOffIcon
                                className={classes.gridTwo}
                                onClick={() => {
                                    setStates({ dialog: false });
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} className={classes.gridFive}>
                            <span className={classes.gridThreeSpan}>Generated Date : </span>
                            <span>{moment(new Date()).format("MM-DD-YYYY")}</span>
                        </Grid>
                    </Grid>
                    {states.response ? (
                        states?.data && states?.data?.length > 0 ? (
                            <TableContainer className={classes.tableContainer}>
                                <Table
                                    className={classes.table}
                                    aria-labelledby="tableTitle"
                                    size={"medium"}
                                    aria-label="enhanced table"
                                >
                                    <TableHead className={classes.tableHead}>
                                        <TableRow>
                                            {states?.selectedColumns.map((h, i) => (
                                                <TableCell key={i} className={classes.tableHeading}>
                                                    <div
                                                        className={
                                                            (states.groupBy === "loyalty_id" && h === "Loyalty ID") ||
                                                            (states.groupBy === "customer_billto_account_number" && h == "Bill to Account ID") ||
                                                            (states.groupBy === "points_expiring" && h === "Point Expiring") ||
                                                            (states.groupBy === "points_expiration_date" && h === "Points Expiration Date") ||
                                                            (states.groupBy === "date_of_transaction" && h === "Date Of Transaction") 
                                                            
                                                           
                                                            ? classes.groupByMarker
                                                            : classes.noDisplay
                                                        }
                                                    >
                                                        {`( Sort by )`}
                                                    </div>
                                                    <div>
                                                        {h}
                                                    </div>
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                    {states?.data.slice(0, 10)?.map((p, i) => (
                                        <TableRow role="checkbox" tabIndex={-1} key={i}>
                                            <TableCell align="left" className={classes.rowCell}>
                                            {p?.loyalty_id}
                                            </TableCell>
                                            <TableCell align="left" className={classes.rowCell}>
                                            {p?.customer_billto_account_number}
                                            </TableCell>
                                            
                                            <TableCell align="left" className={classes.rowCell}>
                                            {p?.points_expiring}
                                            </TableCell>
                                            <TableCell align="left" className={classes.rowCell}>
                                            {p?.points_expiration_date}
                                            </TableCell>
                                            <TableCell align="left" className={classes.rowCell}>
                                            {p?.date_of_transaction}
                                            </TableCell>
                                        </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        ) : (
                            <NoData />
                        )
                    ) : (
                        <Loader Loading={!states?.response}></Loader>
                    )}
                </div>
                {states.data && states.data.length > 0 && (
                    <Grid container spacing={0}>
                        <Grid xs={12} className={classes.gridFour}>
                            <Button
                                className={classes.previewBtn}
                                onClick={() => {
                                    setStates({ dialog: false });
                                }}
                            >
                                {'Cancel'}
                            </Button>
                            <Button
                                className={classes.exportBtn}
                                onClick={() => {
                                    setStates({ dialog: false });
                                    document.getElementById("csv").click();
                                }}
                            >
                                {'Export CSV'}
                            </Button>
                        </Grid>
                    </Grid>
                )}
            </Dialog>
            <Dialog
                aria-labelledby="simple-dialog-title"
                open={states?.errorDialog}
                style={{ fontFamily: "Segoe-ui" }}
            >
                <div className={classes.dialogParentDiv}>
                    <div style={{ display: "flow-root" }}>
                        <span style={{ float: "right" }}>
                            <HighlightOffIcon
                                style={{
                                    verticalAlign: "-webkit-baseline-middle",
                                    cursor: "pointer",
                                    color: "red",
                                }}
                                onClick={() => {
                                    setStates({ errorDialog: false });
                                }}
                            />
                        </span>
                    </div>
                    <div className={classes.parentText}>
                        {'The date range has fetched'} {states.errorCount} {'records.'} <br />
                        {'Due to Excel/CSV limitation we can only allow for 800,000 recordsfor export.'} <br />
                        {'Please add additional filters to limit your record count to less than 800,000.'}
                    </div>
                </div>
            </Dialog>
        </div>
    );
}
